/**
 * 嵌进弹层引擎的 picker 面板(属性图标 picker / Feed reaction picker)的
 * 交互宿主。菜单壳把容器 click 一律拉回自己的隐藏搜索框(`_clickContainer`
 * → `focusInput()`),面板里的 Filter 输入会被立即夺焦、键入落进菜单搜索层。
 * 与 `xuwo-menu-input` 同一手法:在宿主元素本体上装原生监听,先于祖先
 * `xuwo-menu` 的冒泡处理截断——但只对输入类 target 截断:面板按钮的
 * onClick 靠菜单壳 React root 的事件委托派发,冒泡一律截断会把整个面板
 * 点死。Escape 收面板。
 */
export const bindPickerPanelHost =
  (onEscape: () => void) => (element: HTMLDivElement | null) => {
    if (!element) return;
    const stopInputClick = (event: Event) => {
      if (
        (event.target instanceof HTMLInputElement &&
          !['checkbox', 'radio'].includes(event.target.type)) ||
        event.target instanceof HTMLTextAreaElement
      ) {
        // Checkbox/radio React onChange is delegated from click; let those
        // reach the React root instead of swallowing the toggle event.
        event.stopPropagation();
      }
    };
    const onKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        onEscape();
      }
    };
    element.addEventListener('click', stopInputClick);
    element.addEventListener('keydown', onKeydown);
    return () => {
      element.removeEventListener('click', stopInputClick);
      element.removeEventListener('keydown', onKeydown);
    };
  };
